import PagePanel from "../core/App/PagePanel";
import { LoadingSpinner } from "../core/components/LoadingSpinner";
import { useEffect, useMemo, useState } from 'react';
import { Box, Text } from 'tombac';
import { CommunicationFormModal } from "./CommunicationFormModal/CommunicationFormModal";
import { CommunicationListItem } from "./CommunicationListItem";
import { DeleteCommunicationModal } from "./DeleteCommunicationModal";
import { SendCommunicationEmailModal } from "./SendCommunicationEmailModal";
import { useCommunicationListQuery } from "./communicationsApiHooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommunicationList = ({
  filters
}) => {
  const [hasInProgressEmails, setHasInProgressEmails] = useState(false);
  const {
    data: communicationData,
    isFetching,
    isLoading,
    error
  } = useCommunicationListQuery({
    filters
  }, {
    keepPreviousData: true,
    refetchInterval: hasInProgressEmails ? 2000 : false
  });
  useEffect(() => {
    if (communicationData) {
      setHasInProgressEmails(communicationData.content.some(item => item.emails?.waiting > 0));
    }
  }, [communicationData]);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemToSendMailing, setItemToSendMailing] = useState(null);
  const [isSendMailingModalOpen, setIsSendMailingModalOpen] = useState(false);
  const communicationList = useMemo(() => communicationData?.content.sort((a, b) => b.date.localeCompare(a.date) || b.createdAt.localeCompare(a.createdAt)), [communicationData?.content]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(PagePanel, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(PagePanel, {
      children: /*#__PURE__*/_jsx(Box, {
        $display: "flex",
        $justifyContent: "center",
        $m: "3sp 0",
        children: /*#__PURE__*/_jsx(Text, {
          variant: "secondary",
          children: "Error loading communications."
        })
      })
    });
  }
  if (!communicationData) {
    return null;
  }
  const handleEditClick = item => {
    setItemToEdit(item);
    setIsEditModalOpen(true);
  };
  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };
  const handleDeleteClick = item => {
    setItemToDelete(item);
    setIsDeleteModalOpen(true);
  };
  const handleSendMailingClick = item => {
    setItemToSendMailing(item);
    setIsSendMailingModalOpen(true);
  };
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };
  return /*#__PURE__*/_jsxs(PagePanel, {
    $position: "relative",
    "data-sentry-element": "PagePanel",
    "data-sentry-component": "CommunicationList",
    "data-sentry-source-file": "CommunicationList.tsx",
    children: [isFetching && /*#__PURE__*/_jsx(Box, {
      $position: "absolute",
      $right: "3sp",
      $top: "2sp",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: 1
      })
    }), communicationList.length === 0 && /*#__PURE__*/_jsx(Box, {
      $alignItems: "center",
      $display: "flex",
      $flexDirection: "column",
      $m: "3sp 0",
      children: /*#__PURE__*/_jsx(Text, {
        variant: "secondary",
        children: "No communications found"
      })
    }), communicationList.map(communicationItem => /*#__PURE__*/_jsx(CommunicationListItem, {
      communicationItem: communicationItem,
      onDeleteClick: handleDeleteClick,
      onEditClick: handleEditClick,
      onSendEmailClick: handleSendMailingClick
    }, `list-item-${communicationItem.id}`)), itemToEdit && /*#__PURE__*/_jsx(CommunicationFormModal, {
      communicationItemId: itemToEdit.id,
      isOpen: isEditModalOpen,
      onRequestClose: closeEditModal,
      onSuccess: closeEditModal
    }, `edit-${itemToEdit.id}`), itemToDelete && /*#__PURE__*/_jsx(DeleteCommunicationModal, {
      communicationItem: itemToDelete,
      isOpen: isDeleteModalOpen,
      onSuccess: closeDeleteModal,
      onRequestClose: closeDeleteModal
    }, `delete-${itemToDelete.id}`), itemToSendMailing && /*#__PURE__*/_jsx(SendCommunicationEmailModal, {
      communicationItem: itemToSendMailing,
      isOpen: isSendMailingModalOpen,
      onRequestClose: () => setIsSendMailingModalOpen(false)
    }, `send-email-${itemToSendMailing.id}`)]
  });
};